export default {
    "section": "Seller Information",
    "name": "deal-support-seller-information",
    "items": [
        {
            "type": "inline",
            "text": "Contact Information",
            "props": {},
            "items": [
                {
                    "type": "text-field",
                    "name": "seller-full-name",
                    "width": 0,
                    "props": {
                        "hidden": true,
                        "formula": {
                            "name": "join",
                            "arguments": {
                                "targets": [
                                    "seller-first-name",
                                    "seller-last-name"
                                ]
                            }
                        }
                    }
                },
                {
                    "type": "text-field",
                    "name": "seller-first-name",
                    "width": 3,
                    "props": {
                        "label": "First Name"
                    }
                },
                {
                    "type": "text-field",
                    "name": "seller-last-name",
                    "width": 3,
                    "props": {
                        "label": "Last Name"
                    }
                }
            ],
            "subItems": [
                {
                    "type": "text-field",
                    "text": " ",
                    "name": "seller-address",
                    "props": {
                        "label": "Notice Address"
                    }
                },
                {
                    "type": "inline",
                    "text": " ",
                    "items": [
                        {
                            "type": "text-field",
                            "name": "seller-city",
                            "width": 3,
                            "props": {
                                "label": "City"
                            }
                        },
                        {
                            "type": "selectlist",
                            "name": "seller-state",
                            "width": 1,
                            "props": {
                                "label": "State",
                                "items": []
                            }
                        },
                        {
                            "type": "text-field",
                            "name": "seller-zip",
                            "width": 2,
                            "props": {
                                "label": "Zip"
                            }
                        }
                    ]
                },
                {
                    "type": "inline",
                    "text": " ",
                    "items": [
                        {
                            "type": "text-field",
                            "text": "Email Address",
                            "name": "seller-email",
                            "width": 3,
                            "props": {
                                "label": "Email Address"
                            }
                        },
                        {
                            "type": "text-field",
                            "text": "Phone Number",
                            "name": "seller-phone",
                            "width": 3,
                            "props": {
                                "label": "Phone Number"
                            }
                        }
                    ]
                }
            ]
        },
        {
            "type": "text-field",
            "text": "BD/Custodian",
            "name": "seller-bd-custodian",
            "props": {
                "label": "BD/Custodian"
            }
        },
        {
            "type": "text-field",
            "text": "Formal Company Name",
            "name": "seller-company-name",
            "props": {
                "label": "Company Name"
            },
            "subItems": [
                {
                    "type": "text-field",
                    "text": "DBA (if applicable)",
                    "name": "seller-company-dba",
                    "props": {
                        "label": "DBA"
                    }
                }
            ]
        },
        {
            "text": "Entity Type",
            "type": "selectlist",
            "name": "seller-entity-type",
            "width": 3,
            "props": {
                "label": "Entity Type",
                "items": []
            }
        },
        {
            "type": "text-field",
            "text": "Principal Place of Business",
            "name": "seller-principle-address-street",
            "props": {
                "label": "Address"
            },
            "subItems": [
                {
                    "type": "inline",
                    "text": " ",
                    "props": {},
                    "items": [
                        {
                            "type": "text-field",
                            "name": "seller-principle-address-city",
                            "width": 3,
                            "props": {
                                "label": "City"
                            }
                        },
                        {
                            "type": "selectlist",
                            "name": "seller-principle-address-state",
                            "width": 1,
                            "props": {
                                "label": "State",
                                "items": []
                            }
                        },
                        {
                            "type": "text-field",
                            "name": "seller-principle-address-zip",
                            "width": 2,
                            "props": {
                                "label": "Zip"
                            }
                        }
                    ]
                }
            ]
        },
        {
            "type": "selectlist",
            "text": "State of Formation {if applicable)",
            "name": "seller-state-formation",
            "props": {
                "label": "State of Formation",
                "items": []
            }
        },
        {
            "text": "Owners",
            "type": "data-table",
            "name": "seller-owner-information",
            "props": {
                "headers": [
                    {
                        "text": "Name",
                        "value": "full-name"
                    },
                    {
                        "text": "Ownership Percentage",
                        "value": "ownership-percentage",
                        "format": "percent"
                    }
                ],
                "newItemLabel": "Add An Owner",
                "noDataLabel": "Please Add An Owner"
            }
        },
        {
            "type": "text-field",
            "text": "Broker Dealer Payout Percentage",
            "name": "seller-payout-percentage",
            "width": 3,
            "props": {
                "label": "Payout Percentage",
                "format": "percent"
            }
        },
        {
            "type": "radio-list",
            "text": "Practice Type",
            "name": "seller-practice-type",
            "props": {
                "items": []
            },
            "subItems": [
                {
                    "type": "selectlist",
                    "text": "Will the seller move to buyer's broker-dealer to sell business",
                    "name": "seller-change-bd",
                    "props": {
                        "items": [
                            {
                                "text": "Yes",
                                "value": "yes"
                            },
                            {
                                "text": "No",
                                "value": "no"
                            }
                        ]
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "seller-practice-type",
                                "value": "registered-representative"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "type": "selectlist",
            "text": "Please provide the states where your clients are located",
            "name": "seller-client-states",
            "width": 3,
            "props": {
                "multiple": true,
                "items": []
            }
        },
        {
            "type": "input-label",
            "text": "Financial Information",
            "props": {},
            "subItems": [
                {
                    "type": "text-field",
                    "text": "AUM",
                    "name": "seller-financial-aum",
                    "width": 3,
                    "props": {
                        "label": "AUM",
                        "format": "dollars"
                    }
                },
                {
                    "type": "datepicker",
                    "text": "Gross Revenue",
                    "name": "seller-financial-gross-period",
                    "width": 3,
                    "props": {
                        "label": "For 12 Month Period as of:"
                    },
                    "subItems": [
                        {
                            "type": "inline",
                            "text": " ",
                            "items": [
                                {
                                    "name": "seller-financial-payout-type",
                                    "text": "",
                                    "type": "radio-list",
                                    "props": {
                                        "row": true,
                                        "items": [
                                            {
                                                "text": "GDC",
                                                "value": "GDC"
                                            },
                                            {
                                                "text": "Production/Payout",
                                                "value": "Production/Payout"
                                            }
                                        ]
                                    },
                                    "width": 3
                                },
                                {
                                    "name": "seller-financial-payout-percentage",
                                    "text": "Payout Percentage",
                                    "type": "text-field",
                                    "props": {
                                        "label": "Payout Percentage",
                                        "format": "percent"
                                    },
                                    "width": 3
                                }
                            ]
                        },
                        {
                            "type": "inline",
                            "text": " ",
                            "items": [
                                {
                                    "type": "text-field",
                                    "text": "Recurring Revenue",
                                    "name": "seller-financial-gross-recurring",
                                    "width": 3,
                                    "props": {
                                        "label": "Recurring Revenue",
                                        "format": "dollars"
                                    }
                                },
                                {
                                    "type": "text-field",
                                    "text": "Non-Recurring Revenue",
                                    "name": "seller-financial-gross-non-recurring",
                                    "width": 3,
                                    "props": {
                                        "label": "Non-Recurring Revenue",
                                        "format": "dollars"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "type": "text-field",
                    "text": "Expenses",
                    "name": "seller-financial-expenses",
                    "width": 3,
                    "props": {
                        "label": "Expenses",
                        "format": "dollars"
                    }
                }
            ]
        },
        {
            "type": "checkbox-list",
            "text": "Selling as:",
            "name": "seller-selling-as",
            "props": {
                "items": [
                    {
                        "text": "Individual",
                        "value": "individual"
                    },
                    {
                        "text": "Company",
                        "value": "company"
                    }
                ]
            }
        },
        {
            "type": "radio-list",
            "text": "Selling:",
            "name": "seller-selling",
            "props": {
                "items": [
                    {
                        "text": "Partial Book Sale",
                        "value": "partial-book"
                    },
                    {
                        "text": "Full Sale",
                        "value": "full"
                    }
                ]
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/deal-support/valuation-data/seller.js